import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

function roleToRoute(role) {
  switch (role) {
    case 'admin':            return '/dashboard/admin';
    case 'sales_rep':        return '/dashboard/sales';
    case 'contractor':       return '/dashboard/contractor';
    case 'contractor_admin': return '/dashboard/contractor-admin';
    case 'client':           return '/dashboard/client';
    default:                 return '/dashboard';
  }
}

function ProtectedRoute({ children, allowedRoles }) {
  const { user, profile, loading, adminVerified } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-surface">
        <div className="w-16 h-16 border-4 border-yellow-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles) {
    if (!profile) {
      return (
        <div className="flex justify-center items-center min-h-screen bg-surface">
          <div className="w-16 h-16 border-4 border-yellow-500 border-t-transparent rounded-full animate-spin"></div>
        </div>
      );
    }

    const isAdmin = profile.role === 'admin';

    if (!isAdmin && !allowedRoles.includes(profile.role)) {
      const correct = roleToRoute(profile.role);
      return <Navigate to={correct} replace />;
    }
  }

  if (profile?.role === 'admin' && !adminVerified && location.pathname !== '/admin-verify') {
    return <Navigate to="/admin-verify" state={{ from: location }} replace />;
  }

  return children;
}

export default ProtectedRoute;
